import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  ExpirationTimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsOpenedCurrentConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-opened-current-details",
  templateUrl: "./manuals-opened-current-details.component.html",
  standalone: false,
})
export class ManualsOpenedCurrentDetailsComponent
  extends BaseDetailsLogic<ManualsOpenedCurrentConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(
      analyticsService,
      authService,
      loggingService,
      ManualsOpenedCurrentConfig,
      tooltipCoordinator
    );
  }

  get sessionExpirationPeriod(): string | ExpirationTimePeriod {
    return this.config?.sessionExpirationPeriod as ExpirationTimePeriod;
  }

  set sessionExpirationPeriod(value: string | ExpirationTimePeriod) {
    this.config.sessionExpirationPeriod = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  // get selectedMinOpened(): number {
  //   return this.config?.minOpened || 1;
  // }

  // set selectedMinOpened(value: number) {
  //   this.config.minOpened = value;
  //   this.detectSettingsChange();
  //   this.refreshDataFromFilters();
  // }

  // get selectedNumberResults(): number {
  //   return this.config?.top || 1;
  // }

  // set selectedNumberResults(value: number) {
  //   this.config.top = value;
  //   this.detectSettingsChange();
  //   this.refreshDataFromFilters();
  // }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      expirationTimePeriod:
        'Choose how long a session should last before it is considered expired. For example, if you select "30 minutes", any manual that has not been opened in the last 30 minutes will be considered inactive. This helps you see which manuals are currently being used.',
    };
  }
}
